  <ng-container>
    <div class="header-wrap">
      <div class="header">
        <ng-container *ngIf="callDetails.agentFirstName === 'Misha'">
          <img [src]="'/assets/img/conference/misha.jpg'">
        </ng-container>
        <ng-container *ngIf="callDetails.agentFirstName === 'Amanda'">
          <img [src]="'/assets/img/conference/amanda.jpg'">
        </ng-container>
        <div class="header-text-wrap">
          <div class="breadcrumb-wrap">
            <span (click)="goBack()" class="link">{{ "__CALLS_CALL_HISTORY__" | translate }}</span>&nbsp;> {{ capitalizeStr(callDetails.callType) + ' Call with ' + callDetails.agentFirstName }}
          </div>
          <div class="text-muted-foreground">
            <ion-icon name="calendar"></ion-icon>
            <div>{{ callDetails.createdAt | date }}</div>
          </div>
        </div>
      </div>
      <div class="support" style="display: flex; align-items: center; gap: 1rem;">
        <ion-spinner
          *ngIf="isPdfGenerating"
          class="m-r-16"
        ></ion-spinner>
        <ion-button
          class="m-l-8 m-r-8"
          style="white-space: nowrap;"
          [disabled]="isPdfGenerating"
          (click)="generatePDF()"
        >
          {{ "__CALLS_DOWNLOAD_PDF__" | translate }}
        </ion-button>
        <ion-button (click)="goBack()">{{ "__CALLS_BACK__" | translate }}</ion-button>
      </div>
    </div>

    <div class="row row-main" [attr.data-tab]="selectedTab">
      <div #leftInfo class="left-info">
        <ng-container *ngIf="score >= 80">
          <div class="score-wrap">
            {{ "__CALLS_CALL_DETAILS_GREETING_NOTIFICATION__" | translate }}
            <div class="score-circle green">
              {{ score }}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="score >= 60 && score < 80">
          <div class="score-wrap">
            {{ "__CALLS_CALL_DETAILS_GREETING_NOTIFICATION__" | translate }}
            <div class="score-circle yellow">
              {{ score }}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="score >= 40 && score < 60">
          <div class="score-wrap">
            {{ "__CALLS_CALL_DETAILS_NEED_SOME_WORK_NOTIFICATION__" | translate }}
            <div class="score-circle orange">
              {{ score }}
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="score < 40">
          <div class="score-wrap">
            {{ "__CALLS_CALL_DETAILS_JUST_THE_BEGINNING_NOTIFICATION__" | translate }}
            <div class="score-circle red">
              {{ score }}
            </div>
          </div>
        </ng-container>

        <ion-tabs>
          <ion-tab-bar slot="top">
            <ion-tab-button (click)="selectedTab = 'scorecard'" [class.active]="selectedTab === 'scorecard'">
              <ion-label>{{ "__CALLS_SCORECARD__" | translate }}</ion-label>
            </ion-tab-button>
            <ion-tab-button (click)="selectedTab = 'ai-coaching'" [class.active]="selectedTab === 'ai-coaching'">
              <ion-label>{{ "__CALLS_AI_COACHING__" | translate }}</ion-label>
            </ion-tab-button>
            <ion-tab-button disabled>
              <ion-label>{{ "__CALLS_OBJECTIONS__" | translate }}</ion-label>
            </ion-tab-button>
            <ion-tab-button (click)="selectedTab = 'transcript'"
              class="transcript-tab"
              [class.active]="selectedTab === 'transcript'"
            >
              <ion-label>{{ "__CALLS_TRANSCRIPT__" | translate }}</ion-label>
            </ion-tab-button>
          </ion-tab-bar>
        </ion-tabs>

        <div [ngStyle]="{'display': selectedTab === 'scorecard' ? 'block' : 'none'}">
          <app-call-details-scorecard-tab
            [scorecard]="callDetails?.scorecard"
            (navigateToAI)="onNavigateToAI($event)"
          ></app-call-details-scorecard-tab>
        </div>

        <div [ngStyle]="{'display': selectedTab === 'ai-coaching' ? 'block' : 'none'}">
          <app-call-details-ai-coaching-tab
            #aiCoachingTab
            *ngIf="callDetails?.scorecard"
            [criteria]="callDetails.scorecard.criteria"
          ></app-call-details-ai-coaching-tab>
        </div>
      </div>

      <div #rightInfo class="right-info">
        <div class="player" *ngIf="isAudioEnabled">
          <div class="right-info-header-wrap">
            <div class="right-info-header-left">
              <div class="title">{{ "__CALLS_RECORDING__" | translate }}</div>
            </div>
          </div>
          <app-call-audio-player #audioPlayer [callId]="callDetails.id" [discussionAudio]="discussionAudio"></app-call-audio-player>
        </div>
        <div class="transcript">
          <div class="right-info-header-wrap">
            <div class="right-info-header-left">
              <div class="title">{{ "__CALLS_TRANSCRIPT__" | translate }}</div>
              <!-- <div class="subtitle">Click on messages to skip to that part of the audio</div> -->
            </div>
            <div class="right-info-header-right">
              <ion-icon name="download" class="right-info-header-btn" (click)="downloadTxtFile()"></ion-icon>
              <ion-icon
                [style]="{'color': isTranscriptCopied ? 'green' : ''}"
                name="copy"
                class="right-info-header-btn"
                (click)="copyTranscriptToClipboard()"
              ></ion-icon>
            </div>
          </div>
          <app-call-details-chat
            [transcript]="callDetails.transcript"
            [agentFirstName]="callDetails.agentFirstName"
            [userFirstName]="callDetails.userFirstName"
            [userLastName]="callDetails.userLastName"
            (jumpToTime)="onJumpToTime($event)"
          ></app-call-details-chat>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="printed-version" #scorecardContent>
    <div class="print-title">{{ "__CALLS_CALL_REPORT__" | translate }} - {{ callDetails.date | date }}</div>

    <div class="print-header">
      <div>
        <div><b>User:</b> {{ callDetails.userFirstName }} {{ callDetails.userLastName }} ({{ callDetails.userEmail }})</div>
        <div><b>Coach:</b> {{ callDetails.agentFirstName }} {{ callDetails.agentLastName }} - {{ callDetails.callType | titlecase }}</div>
      </div>
      <div style="font-size: large; font-weight: 700;"><span
        style="font-weight: 300;">Score:</span> {{ callDetails.score * 100 | number: '1.0-0' }}
      </div>
    </div>

    <app-call-details-scorecard-tab
      [scorecard]="callDetails.scorecard"
      [print]="true"
    ></app-call-details-scorecard-tab>

    <app-call-details-ai-coaching-tab-print
      *ngIf="callDetails.scorecard"
      [criteria]="callDetails.scorecard.criteria"
      [open]="true"
      [print]="true"
    >
    </app-call-details-ai-coaching-tab-print>
  </div>
  <div class="printed-version" #scorecardContent2>
    <div
      class="print-title"
      style="font-size: x-large; padding-top: 2rem;"
    >Transcript - {{ callDetails.duration / 1000 | secToString }}
    </div>
    <app-call-details-chat
      [transcript]="callDetails.transcript"
      [agentFirstName]="callDetails.agentFirstName"
      [userFirstName]="callDetails.userFirstName"
      [userLastName]="callDetails.userLastName"
      [print]="true"
    >
    </app-call-details-chat>
  </div>
